(() => {
  const configElement = document.getElementById('cil-mobile-order-config');
  if (!configElement || window.cilsonMobileOrder) return;
  window.cilsonMobileOrder = true;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  const labels = config.labels;
  const mobile = window.matchMedia('(max-width: 749px)');
  const info = document.querySelector('.product__info-container');
  const cartFooter = document.getElementById('main-cart-footer');
  let queued = false;
  let metreDetails;
  const text = (element, value) => { if (element.textContent !== value) element.textContent = value; };

  const choices = () => {
    if (!info) return;
    const links = Array.from(info.querySelectorAll('.cil-chip'));
    const row = links[0] && links[0].closest('.cil-sib-row');
    if (row && !row.classList.contains('cil-size-grid')) {
      row.classList.add('cil-size-grid');
      links.forEach((link) => {
        const dimension = link.textContent.trim().match(/^(\d+)\s*[×x]\s*(\d+)$/i);
        if (dimension) {
          const measure = document.createElement('span');
          measure.className = 'cil-size-dim';
          measure.textContent = dimension[1] + ' × ' + dimension[2];
          const unit = document.createElement('span');
          unit.className = 'cil-size-unit';
          unit.textContent = ' mm';
          link.replaceChildren(measure, unit);
        }
        if (new URL(link.href).pathname === new URL(document.baseURI).pathname) {
          link.setAttribute('aria-current', 'page');
        }
      });
    }
    const metres = info.querySelector('.cil-mh');
    if (mobile.matches && metres && !metreDetails) {
      metreDetails = document.createElement('details');
      metreDetails.className = 'cil-mobile-metres';
      const summary = document.createElement('summary');
      summary.textContent = labels.metres;
      metres.insertAdjacentElement('beforebegin', metreDetails);
      metreDetails.append(summary, metres);
    } else if (!mobile.matches && metreDetails) {
      const child = metreDetails.querySelector('.cil-mh');
      if (child) metreDetails.replaceWith(child);
      metreDetails = null;
    }
    info.querySelectorAll('.cil-stf-card').forEach((card) => {
      card.setAttribute('aria-pressed', String(card.classList.contains('aktiv')));
    });
    const input = info.querySelector('input[name="quantity"]');
    if (input) {
      input.inputMode = 'numeric';
      input.setAttribute('autocomplete', 'off');
    }
  };

  const sourceButton = () => info
    ? info.querySelector('.product-form__submit')
    : cartFooter && cartFooter.querySelector('.cart__checkout-button');
  const source = sourceButton();
  let bar;
  let action;
  let summary;
  let price;
  if (source) {
    bar = document.createElement('div');
    bar.className = 'cil-sbar cil-mobile-order-bar' + (cartFooter ? ' cil-mobile-checkout-bar' : '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', cartFooter ? labels.checkout : labels.selection);
    bar.hidden = true;
    bar.inert = true;
    const detail = document.createElement('div');
    detail.className = 'cil-sbar-info';
    summary = document.createElement('div');
    summary.className = 'cil-sbar-t';
    price = document.createElement('div');
    price.className = 'cil-sbar-p';
    action = document.createElement('button');
    action.type = 'button';
    action.className = 'cil-sbar-btn';
    detail.append(summary, price);
    bar.append(detail, action);
    document.body.appendChild(bar);
    action.addEventListener('click', () => {
      const current = sourceButton();
      if (!current || current.disabled || current.getAttribute('aria-disabled') === 'true') return;
      if (info && current.getBoundingClientRect().top > 0) {
        const input = info.querySelector('input[name="quantity"]');
        const target = input || current;
        target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        target.focus({ preventScroll: true });
        return;
      }
      const form = current.form;
      if (form && !form.reportValidity()) return;
      current.click();
    });
  }

  const draw = () => {
    queued = false;
    choices();
    if (!bar) return;
    const current = sourceButton();
    if (!current) return;
    const box = current.getBoundingClientRect();
    const before = box.top >= window.innerHeight;
    const after = box.bottom <= 0;
    document.body.classList.toggle('cil-order-controls-active', mobile.matches && !!info && box.top < window.innerHeight && box.bottom > 0);
    const focused = document.activeElement;
    const editing = focused && /^(INPUT|TEXTAREA|SELECT)$/.test(focused.tagName);
    const overlay = document.body.classList.contains('cil-atc-open') ||
      document.querySelector('dialog[open], .menu-opening, cart-drawer.active, .product-media-modal[open], .pickup-availability-drawer[open]');
    const busy = current.disabled || current.getAttribute('aria-disabled') === 'true' || current.classList.contains('cil-busy') ||
      !!document.querySelector('cart-items .cart__items--disabled');
    let visible = mobile.matches && box.width > 0 && box.height > 0 && !overlay && !editing && (before || after);
    if (cartFooter) {
      const total = cartFooter.querySelector('.totals__subtotal-value');
      visible = visible && !!document.querySelector('cart-items .cart-item');
      text(summary, labels.subtotal);
      text(price, total ? total.textContent.trim() : '');
      text(action, labels.checkout);
    } else {
      const input = info.querySelector('input[name="quantity"]');
      const quantity = Number(input && input.value);
      const valid = Number.isInteger(quantity) && quantity > 0 && (!input || input.validity.valid);
      const total = info.querySelector('.cil-nb-sum-r2 b');
      const unit = info.querySelector('.cil-nb-line1 b');
      const raw = info.querySelector('.price-item');
      const selectedId = info.querySelector('form[action*="/cart/add"] input[name="id"]');
      // 01.11.2026: Pakete (SKU …-P10/-P20) als „1 Paket · 20 m“ statt „1 Stück · 2 m“
      const pack = Number(config.variantPacks && selectedId && config.variantPacks[selectedId.value]) || 0;
      const metres = pack ? pack * 2 : (Number(config.variantLengths && selectedId && config.variantLengths[selectedId.value]) || 0);
      const lang = (document.documentElement.lang || 'de').slice(0, 2);
      const packWords = { de: ['Paket', 'Pakete'], en: ['pack', 'packs'], fr: ['lot', 'lots'], it: ['confezione', 'confezioni'], nl: ['pakket', 'pakketten'], es: ['paquete', 'paquetes'], pl: ['pakiet', 'pakiety'] }[lang] || ['Paket', 'Pakete'];
      const unitWord = pack ? packWords[quantity === 1 ? 0 : 1] : labels.pieces;
      text(summary, valid ? quantity + ' ' + unitWord + (metres > 0 ? ' · ' + (quantity * metres) + ' m' : '') : config.productTitle || labels.selection);
      text(price, total && !total.closest('[hidden]') ? total.textContent.trim() : quantity === 1 && (unit || raw) ? (unit || raw).textContent.trim() : '');
      text(action, before ? labels.selection : labels.add);
      action.disabled = busy || !valid;
    }
    if (cartFooter) action.disabled = busy;
    bar.hidden = !visible;
    bar.inert = !visible;
    bar.classList.toggle('an', visible);
    document.body.classList.toggle('cil-sbar-on', visible);
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(draw); }
  };
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('cilson:cart-updated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
  const root = info || (cartFooter && document.getElementById('MainContent'));
  if (root) new MutationObserver(schedule).observe(root, {
    childList: true, subtree: true, characterData: true, attributes: true,
    attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden']
  });
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (source && 'IntersectionObserver' in window) new IntersectionObserver(schedule).observe(source);
  draw();
})();
